export default __webpack_public_path__ + "static/media/clock-programming.330bad34.svg";